/**
 * Represents how an external task source will be displayed
 */ export var ExternalTaskSourceDisplayType;
(function(ExternalTaskSourceDisplayType) {
    ExternalTaskSourceDisplayType["None"] = "none";
    ExternalTaskSourceDisplayType["Default"] = "default";
})(ExternalTaskSourceDisplayType || (ExternalTaskSourceDisplayType = {}));
